import { Formik, Form, Field } from 'formik';
import { InputPhone } from 'components/inputs/phoneInput';
import axios from 'axios';
import { validationPhone } from './validation';
import Logo from 'assets/images/svg/icon_logo.svg';
import { useState, useCallback } from 'react';
import { Spinner } from '../../Spinner/Spinner';
import { SmartCaptcha } from '@yandex/smart-captcha'

export const PhoneStep = ({
  nextStep,
  setPhone,
  setIsnew,
  setExpiredIn,
  setSmsError,
  setPollComplete
}) => {
  const [isLoad, setIsLoad] = useState(false)
  const [token, setToken] = useState('')
  const [visible, setVisible] = useState(false)
  const handleChallengeHidden = useCallback(() => setVisible(false), [])

  return (
    <section className='login'>
      <a href={'/'} className='logo'>
        <div className='logo__img'>
          <img
            src={Logo}
            alt=''
            className='svg'
            width={91}
            height={78}
          />
        </div>
        <h2 className='logo__title logo__title-login01'>
          ПРИНЯТЬ УЧАСТИЕ В ЖЕНСКОМ ДВИЖЕНИИ ЕДИНОЙ РОССИИ
        </h2>
      </a>
      <p className='login__text'>
        Оставьте ваши контактные данные для информирования о мероприятиях
        проекта «Женское движение ЕДИНОЙ РОССИИ» в Вашем регионе, а также
        получения информационных материалов
      </p>
      <div className='login__content'>
        <p className='login__info'>
          Пожалуйста, введите свой мобильный телефон — Вам будет отправлен
          одноразовый пароль для входа.
        </p>
        <Formik
          initialValues={{ phone: '', personal_data_confirmation: false }}
          validate={(values) => {

            return validationPhone(values);
          }}
          onSubmit={async (values) => {
            const prepPhone = values.phone
              .replaceAll(/[+()\-\s]/g, '')
              .substring(1);
            setIsLoad(true)
            return axios
              .post('/auth/authenticate', {
                phone: prepPhone,
                personal_data_confirmation: values.personal_data_confirmation,
                captcha_token: token
              })
              .then((data) => {
                if (data.data.expired) {
                  setExpiredIn(data.data.expired);
                  setSmsError(true);
                }
                setPhone(prepPhone);
                nextStep();
              })
              .catch((e) => {
                console.log(e);
              }).finally(() => setIsLoad(false))
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            isValid,
            setFieldValue,
          }) => (
            <Form
              className='login__form form js-form js-ajax-form'
              onSubmit={handleSubmit}
            >
              <div className='form__wrap'>
                <label className='form__label' htmlFor='phone'>
                  Номер телефона*
                  <InputPhone
                    disabled={isLoad}
                    className={'form__input js-input-phone' + (errors.phone ? ' error' : '')}
                    onChange={(e) => {
                      if (e.target.value[4] !== '9')
                        return setFieldValue('phone', true);
                      return setFieldValue('phone', e.target.value);
                    }}
                    onBlur={handleBlur}
                    value={values.phone}
                  />
                  <span className='authorization__error'>
                    {errors.phone && touched.phone && errors.phone}
                  </span>
                </label>
                {/* <img src={Phone} alt='phone' /> */}

                <button
                  className='form__button button'
                  type='submit'
                  disabled={isLoad || !token}
                >
                  {isLoad && <div className="form_loader"><Spinner /></div>}
                  <span className="form__btn-text">Получить смс</span>
                </button>
              </div>

              <label
                className='form__checkbox'
                htmlFor='personal_data_confirmation'
              >
                <Field
                  id='personal_data_confirmation'
                  name='personal_data_confirmation'
                  type='checkbox'
                  className='form__checkbox-box'
                  onChange={handleChange}
                  disabled={isLoad}
                />
                <span className='form__checkbox-text'>
                  Я даю согласие на обработку моих персональных данных
                  в соответствии ФЗ №152-ФЗ «О персональных данных» и на{' '}
                  <a
                    style={{ color: '#2896FF' }}
                    target={'_blank'}
                    rel='noreferrer'
                    href='https://er.ru/upages/privacy-policy'
                  >
                    Политику конфиденциальности - Показать подробности
                  </a>
                </span>
              </label>
              <span className='authorization__error'>
                {errors.personal_data_confirmation &&
                  touched.personal_data_confirmation &&
                  errors.personal_data_confirmation}
              </span>
              <div className="authorization__input-group captcha">
                  <div className="authorization__input-block">
                    <SmartCaptcha
                      sitekey={process.env.REACT_APP_YANDEX_CAPTCHA}
                      onSuccess={setToken}
                      onChallengeHidden={handleChallengeHidden}
                      visible={visible}
                      hideShield={true}
                    />
                  </div>
                </div>
            </Form>
          )}
        </Formik>
      </div>
    </section>
  );
};
